var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('div', {
    staticClass: "\n      text-center\n      d-flex\n      justify-content-center\n      align-items-center\n      fetching\n    "
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary"
    }
  })], 1) : _vm._e(), _vm.errorMessage ? _c('div', {
    staticClass: "\n      container\n      error-message-box\n      justify-content-center\n      align-items-center\n    "
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.errorMessage))]), _c('p', [_vm._v(" 聊天室代碼：" + _vm._s(_vm.chatroomId) + " ")]), _vm.$store.state.liffChatroom.asStaff ? _c('p', [_vm._v(" 管理帳號代碼：" + _vm._s(this.senderId) + " ")]) : _vm._e(), !_vm.$store.state.liffChatroom.asStaff ? _c('p', [_vm._v(" 會員顧客代碼：" + _vm._s(this.senderId) + " ")]) : _vm._e(), _vm.$store.state.liffChatroom.user.outer_code ? _c('p', [_vm._v(" 錯誤代碼: " + _vm._s(_vm.$store.state.liffChatroom.user.outer_code) + " ")]) : _vm._e(), _c('b-button', {
    staticClass: "mb-1 mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 回官方帳號 ")])], 1)]) : [_vm.chatroom ? _c('div', {
    ref: "chatbox",
    staticClass: "chatbox flex-fill",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "chatbox-header sticky-top"
  }, [_c('header', {
    staticClass: "\n            d-flex\n            justify-content-between\n            align-items-center\n            border-bottom\n          "
  }, [_c('span', {
    staticClass: "text-left d-sm-none"
  }, [_vm.showBackButton ? _c('b-link', {
    staticClass: "btn text-white",
    attrs: {
      "to": {
        name: 'LiffChatroomIndex'
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256 512",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
    }
  })]), _vm._v(" 返回 ")]) : _vm._e()], 1), _c('h1', {
    staticClass: "ml-2"
  }, [[_c('b-avatar', {
    staticClass: "mr-3",
    attrs: {
      "src": _vm.getChatroomAvatar(_vm.chatroom)
    }
  }), _vm._v(_vm._s(_vm.resolveTitle(_vm.chatroom)) + " ")]], 2), _c('span', {
    staticClass: "text-right"
  }, [_vm.hasAnyTool ? _c('b-button', {
    staticClass: "text-white p-2",
    attrs: {
      "variant": "link",
      "aria-label": _vm.showToolbar ? '關閉' : '功能'
    },
    on: {
      "click": _vm.toggleToolbar
    }
  }, [!_vm.showToolbar ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "fill": "white",
      "width": "20",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "white",
      "width": "20",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  })])]) : _vm._e()], 1)]), _vm.showToolbar && !_vm.showRecallCheckBox ? _c('div', {
    staticClass: "chat-toolbar d-flex flex-wrap align-items-center px-3 py-2 border-bottom bg-white"
  }, [_vm.isMessageSearching ? [_c('div', {
    staticClass: "d-flex flex-nowrap align-items-center w-100"
  }, [_c('b-form-input', {
    staticClass: "flex-fill",
    attrs: {
      "type": "search",
      "placeholder": "搜尋訊息",
      "debounce": "300"
    },
    on: {
      "update": _vm.handleSearchInput
    },
    model: {
      value: _vm.searchKeyword,
      callback: function callback($$v) {
        _vm.searchKeyword = $$v;
      },
      expression: "searchKeyword"
    }
  }), _c('b-button', {
    staticClass: "ml-2 text-muted px-2 flex-shrink-0",
    attrs: {
      "size": "sm",
      "variant": "link"
    },
    on: {
      "click": _vm.exitSearch
    }
  }, [_vm._v(" ✕ ")])], 1)] : [_vm.allowPin ? _c('b-button', {
    staticClass: "mr-2 mb-1",
    attrs: {
      "variant": _vm.isPinned ? 'warning' : 'outline-warning',
      "size": "sm"
    },
    on: {
      "click": _vm.handleTogglePin
    }
  }, [_vm._v(" " + _vm._s(_vm.isPinned ? '取消釘選' : '釘選') + " ")]) : _vm._e(), _vm.allowStatus ? _c('b-dropdown', {
    staticClass: "mr-2 mb-1",
    attrs: {
      "variant": _vm.statusVariant,
      "size": "sm",
      "text": _vm.statusText
    }
  }, _vm._l(_vm.statusOptions, function (opt) {
    return _c('b-dropdown-item', {
      key: opt.value,
      on: {
        "click": function click($event) {
          return _vm.handleSetStatus(opt.value);
        }
      }
    }, [_vm._v(" " + _vm._s(opt.text) + " ")]);
  }), 1) : _vm._e(), _vm.allowRecall ? _c('b-button', {
    staticClass: "mr-2 mb-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.enterRecallMode
    }
  }, [_vm._v(" 回收訊息 ")]) : _vm._e(), _vm.allowSearch ? _c('b-button', {
    staticClass: "mr-2 mb-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_vm._v(" 搜尋 ")]) : _vm._e()]], 2) : _vm._e(), _vm.showRecallCheckBox ? _c('div', {
    staticClass: "recall-bar d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-white"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "link"
    },
    on: {
      "click": _vm.cancelRecallMode
    }
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "small text-muted"
  }, [_vm._v("已選擇 " + _vm._s(_vm.selectedRecallMessages.length) + " 則")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger",
      "disabled": _vm.messageRecalling || !_vm.selectedRecallMessages.length
    },
    on: {
      "click": _vm.handleRecallSubmit
    }
  }, [_vm._v(" 回收 ")])], 1) : _vm._e()]), _c('div', {
    staticClass: "\n          chatbox-inner\n          d-flex\n          flex-column-reverse\n          px-3\n          position-relative\n        "
  }, [_vm.chatroomLoaded && !_vm.displayMessages.length ? _c('div', {
    staticClass: "message-box my-2"
  }, [_c('div', {
    staticClass: "strike small text-muted pb-2"
  }, [_vm._v(_vm._s(_vm.inSearchMode ? '找不到符合的訊息' : '對話開始'))])]) : _vm._e(), _vm._l(_vm.displayMessages, function (message, idx) {
    return _c('div', {
      key: message.id,
      class: ['message-box', 'my-2', message.sender.outer_code == _vm.$store.state.liffChatroom.user.outer_code && message.sender.type == (_vm.$store.state.liffChatroom.asStaff ? 'staff' : 'customer') && 'owner'],
      attrs: {
        "id": "message-".concat(message.id)
      }
    }, [_vm.firstMessage && _vm.firstMessage.id === message.id && _vm.firstLoad ? _c('div', {
      staticClass: "strike small text-muted pb-2"
    }, [_vm._v(" 對話開始 ")]) : _vm.firstNewMessage && _vm.firstNewMessage.id === message.id ? _c('div', {
      staticClass: "strike small text-muted pb-2"
    }, [_vm._v(" 最新訊息 ")]) : _vm.firstUnreadMessage && _vm.firstUnreadMessage.id === message.id ? _c('div', {
      staticClass: "strike small text-muted pb-2"
    }, [_vm._v(" 未讀 ")]) : _vm._e(), _vm.checkStrike(_vm.displayMessages, idx) ? _c('div', {
      staticClass: "strike small text-muted pb-2"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.displayMessages[idx].created_at, '今天')) + " ")]) : _vm._e(), _c('div', {
      staticClass: "message-wrapper"
    }, [_c('div', {
      staticClass: "d-flex align-items-start"
    }, [_vm.showRecallCheckBox && _vm.isMessageOwner(message) && message.content !== '(訊息已收回)' && message.type !== 'image' && _vm.canRecallByHours(message) ? _c('div', {
      staticClass: "mr-2 pt-2 custom-control custom-checkbox"
    }, [_c('input', {
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "id": 'liff_recall_cb_' + message.id,
        "disabled": _vm.messageRecalling
      },
      domProps: {
        "value": message.id,
        "checked": _vm.isMessageSelected(message.id, message.type)
      },
      on: {
        "change": function change($event) {
          return _vm.handleRecallToggle(message.id, message.type);
        }
      }
    }), _c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": 'liff_recall_cb_' + message.id
      }
    })]) : _vm._e(), !(message.sender.outer_code == _vm.$store.state.liffChatroom.user.outer_code && message.sender.type == (_vm.$store.state.liffChatroom.asStaff ? 'staff' : 'customer')) ? _c('b-avatar', {
      staticClass: "mr-2",
      attrs: {
        "src": message.sender.avatar_url
      }
    }) : _vm._e(), _c('div', [!(message.sender.outer_code == _vm.$store.state.liffChatroom.user.outer_code && message.sender.type == (_vm.$store.state.liffChatroom.asStaff ? 'staff' : 'customer')) ? _c('small', {
      staticClass: "mb-1"
    }, [_vm._v(" " + _vm._s(message.sender.name) + " ")]) : _vm._e(), message.type === 'image' && message.meta.images.length > 0 ? [_c('div', {
      staticClass: "message image",
      class: {
        multiple: message.meta.images && message.meta.images.length > 1
      }
    }, _vm._l(message.meta.images, function (image, i) {
      return _c('div', {
        key: i,
        class: {
          expanded: message.meta.images.length & 1 && i === 0
        }
      }, [_c('img', {
        attrs: {
          "src": image.previewImageUrl
        },
        on: {
          "click": function click($event) {
            _vm.showImageLightBox(_vm.getLightBoxSrcs(message), i);
          }
        }
      })]);
    }), 0)] : message.type === 'file' && message.content != '(訊息已收回)' ? _c('div', {
      staticClass: "message file py-2 px-3"
    }, [_c('a', {
      attrs: {
        "href": _vm.fileSelector(message.meta),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 384 512",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M374.6 310.6l-160 160C208.4 476.9 200.2 480 192 480s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 370.8V64c0-17.69 14.33-31.1 31.1-31.1S224 46.31 224 64v306.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0S387.1 298.1 374.6 310.6z"
      }
    })])]), _c('div', {
      staticClass: "info"
    }, [_c('p', [_vm._v(_vm._s(message.meta.fileName))]), _c('p', [_vm._v(_vm._s(_vm.filesizeForHuman(message.meta.fileSize)))])])])]) : message.type === 'sticker' && message.content != '(訊息已收回)' ? _c('div', {
      staticClass: "message sticker py-2 px-3"
    }, [_c('img', {
      attrs: {
        "src": message.meta.stickerUrl
      }
    })]) : _c('div', {
      staticClass: "message py-2 px-3",
      class: message.draft ? 'draft-message' : 'message',
      domProps: {
        "innerHTML": _vm._s(_vm.manipulateMessage(message.content))
      }
    })], 2)], 1), _c('div', {
      staticClass: "small text-muted d-flex align-items-end justify-content-end mt-1"
    }, [_c('ul', {
      staticClass: "list-unstyled read-list"
    }, [_vm._l(_vm.senders, function (sender) {
      return [_vm.senderIsRead(sender, message) ? _c('li', {
        key: sender.id,
        attrs: {
          "title": sender.name
        }
      }, [_c('b-avatar', {
        attrs: {
          "size": "1rem",
          "src": sender.avatar_url
        }
      })], 1) : _vm._e()];
    })], 2), !message.draft ? _c('time', [_vm._v(_vm._s(_vm.formatHourMinutes(message.created_at)))]) : _vm._e()])])]);
  }), _vm.typingSenders.length ? _c('div', {
    staticClass: "typing-list"
  }, _vm._l(_vm.typingSenders, function (sender) {
    return _c('div', {
      key: sender.id,
      staticClass: "message-box my-2"
    }, [_c('div', {
      staticClass: "message-wrapper"
    }, [_c('div', {
      staticClass: "d-flex align-items-start"
    }, [_c('b-avatar', {
      staticClass: "mr-2",
      attrs: {
        "src": sender.avatar_url
      }
    }), _c('div', [_c('small', [_vm._v(_vm._s(sender.name))]), _c('div', {
      staticClass: "message py-2 px-3 mt-1"
    }, [_c('Typing')], 1)])], 1)])]);
  }), 0) : _vm._e(), _vm.chatroomLoaded ? _c('div', {
    staticClass: "text-center mt-2 mb-auto loading-spinner small"
  }, [_vm.loading ? _c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  }) : _vm.displayNextCursor ? _c('button', {
    staticClass: "btn btn-secondary btn-small",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.loadMore.apply(null, arguments);
      }
    }
  }, [_vm._v("載入之前的對話")]) : !_vm.firstLoad ? _c('span', [_vm._v("已無對話紀錄")]) : _vm._e()], 1) : _vm._e()], 2), _c('div', {
    staticClass: "typebox py-2 px-3 bg-white border-top"
  }, [_vm.showIndicator || _vm.showScrollToUnreadMessage ? _c('div', {
    staticClass: "position-absolute unread d-flex justify-content-center px-3"
  }, [_vm.showIndicator && _vm.unread ? _c('b-button', {
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('div', {
    staticClass: "last-message-wrapper"
  }, [_vm._v(" " + _vm._s(_vm.latestMessage.sender.name) + "：" + _vm._s(_vm.latestMessage.content) + " ")])]) : _vm.showIndicator && !_vm.bottom ? _c('b-button', {
    staticClass: "px-2",
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "height": "16",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
    }
  })])]) : _vm.showScrollToUnreadMessage ? _c('b-button', {
    staticClass: "show-scroll-to-unread-message-btn px-2",
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToUnreadMessage
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "height": "16",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
    }
  })])]) : _vm._e()], 1) : _vm._e(), _c('input', {
    ref: "file",
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "multiple": _vm.canMultiUpload
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _c('div', {
    staticClass: "d-flex",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.canMultiUpload ? _c('button', {
    staticClass: "btn px-2",
    attrs: {
      "type": "button",
      "disabled": _vm.sending
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.selectFile.apply(null, arguments);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/liff/chatbox/paperclip-2.png"),
      "width": "25",
      "height": "25"
    }
  })]) : _vm._e(), !_vm.canMultiUpload ? _c('b-dropdown', {
    staticClass: "p-0 btn btn-link file",
    attrs: {
      "dropup": "",
      "variant": " px-3",
      "no-caret": "",
      "disabled": _vm.sending
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
      }
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('svg', {
          staticStyle: {
            "width": "16px",
            "height": "16px"
          },
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "d": "M396.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
          }
        })])];
      },
      proxy: true
    }], null, false, 1433916247)
  }, [_c('b-dropdown-item', {
    attrs: {
      "link-class": "d-flex justify-content-between align-items-center"
    },
    on: {
      "click": _vm.selectFile
    }
  }, [_c('span', [_vm._v("單檔")]), _c('svg', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 64C0 28.65 28.65 0 64 0H229.5C246.5 0 262.7 6.743 274.7 18.75L365.3 109.3C377.3 121.3 384 137.5 384 154.5V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM336 448V160H256C238.3 160 224 145.7 224 128V48H64C55.16 48 48 55.16 48 64V448C48 456.8 55.16 464 64 464H320C328.8 464 336 456.8 336 448z"
    }
  })])]), _c('b-dropdown-item', {
    attrs: {
      "link-class": "d-flex justify-content-between align-items-center"
    },
    on: {
      "click": _vm.openMultipleUploadPage
    }
  }, [_c('span', [_vm._v("多檔")]), _c('svg', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M502.6 70.63l-61.25-61.25C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.0195 256C192 355.4 220.7 384 256 384h192c35.2 0 64-28.8 64-64V93.25C512 84.77 508.6 76.63 502.6 70.63zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16L239.1 64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1V320zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16L47.98 192.1c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64l.0098 256C.002 483.3 28.66 512 64 512h192c35.2 0 64-28.8 64-64v-32h-47.1L272 448z"
    }
  })])])], 1) : _vm._e(), _c('div', {
    staticClass: "textbox flex-fill"
  }, [_c('b-form-textarea', {
    ref: "input",
    staticClass: "message-box pl-3",
    style: "--lines: ".concat(_vm.messageLines),
    attrs: {
      "placeholder": "輸入留言",
      "rows": "1",
      "autofocus": false
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }), _c('button', {
    staticClass: "btn send",
    attrs: {
      "type": "button",
      "disabled": _vm.sending
    },
    on: {
      "click": _vm.send
    }
  }, [_c('svg', {
    attrs: {
      "width": "21",
      "height": "18",
      "viewBox": "0 0 21 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.17 6.22991L5.17001 0.449907C4.64029 0.230693 4.05884 0.167851 3.49451 0.26882C2.93018 0.369788 2.4066 0.630339 1.98575 1.01963C1.5649 1.40891 1.2644 1.91064 1.11983 2.4654C0.975262 3.02016 0.992675 3.60473 1.17001 4.14991L2.71001 8.99991L1.13001 13.8499C0.947881 14.3973 0.927422 14.9855 1.07108 15.5442C1.21475 16.1029 1.51644 16.6083 1.94001 16.9999C2.48465 17.505 3.19729 17.79 3.94001 17.7999C4.33474 17.7996 4.72554 17.7215 5.09001 17.5699L19.14 11.7899C19.6872 11.5623 20.1547 11.1778 20.4836 10.6848C20.8125 10.1919 20.988 9.61252 20.988 9.01991C20.988 8.42729 20.8125 7.84795 20.4836 7.35497C20.1547 6.862 19.6872 6.47747 19.14 6.24991L19.17 6.22991ZM4.36001 15.6999C4.18361 15.7727 3.99007 15.7934 3.80225 15.7598C3.61442 15.7261 3.44015 15.6394 3.30001 15.5099C3.168 15.3838 3.07304 15.2239 3.02545 15.0476C2.97785 14.8713 2.97943 14.6854 3.03001 14.5099L4.49001 9.99991H18.22L4.36001 15.6999ZM4.49001 7.99991L3.00001 3.52991C2.94943 3.35446 2.94785 3.16851 2.99545 2.99222C3.04304 2.81594 3.138 2.65606 3.27001 2.52991C3.36412 2.43118 3.47742 2.35275 3.60296 2.29944C3.7285 2.24613 3.86362 2.21906 4.00001 2.21991C4.13406 2.22016 4.26669 2.24737 4.39001 2.29991L18.22 7.99991H4.49001Z",
      "fill": "#09101D"
    }
  })])])], 1)], 1)])]) : _vm._e()], _c('ImageLightBox', {
    ref: "lightbox"
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }